<template>
  <v-container>
    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <!-- Card Image -->
          <v-img
            src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
            aspect-ratio="2.75"
          ></v-img>
          <!-- Card Title -->
          <v-card-title primary-title>
            <div>
              <div class="headline ml-2">Login</div>
            </div>
          </v-card-title>
          <!-- Feedback -->
          <v-alert v-if="feedback" :value="true" type="error" class="mb-3">
            {{ feedback }}
          </v-alert>
          <!-- Card Fields -->
          <v-text-field
            v-model="email"
            label="Email"
            class="ml-4 mr-4"
            hide-details
          ></v-text-field>
          <v-text-field
            v-model="password"
            :append-icon="showPassword ? 'visibility_off' : 'visibility'"
            :type="showPassword ? 'text' : 'password'"
            label="Password"
            hide-details
            @click:append="showPassword = !showPassword"
            class="ma-4"
          ></v-text-field>
          <!-- Card Actions -->
          <v-card-actions>
            <v-btn block color="primary" @click="login" class="mb-3 ml-3 mr-3">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="processingDialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Logging in please wait
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import firebase from 'firebase'
export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      feedback: '',
      showPassword: false,
      processingDialog: false,
    }
  },
  methods: {
    login() {
      if (this.email && this.password ) {
        this.processingDialog = true
        this.feedback = null
        firebase.auth().signInWithEmailAndPassword(
          this.email,
          this.password
        )
        .then( credentials => {
          // console.log( credentials.user )
          this.$router.push({ name: 'Home' })
        })
        .catch( (err) => {
          this.processingDialog = false
          this.feedback = err.message
        })
      } else {
        this.feedback = 'An email and password must be provided.'
      }
      

    }
  }
}
</script>
